import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ImagePlay } from "lucide-react";
import { useTheme } from "@/providers/theme-provider";
import { useTranslation } from "@/providers/language-provider";
import { useState } from "react";
import { GifPicker } from "gif-picker-react";
import { Klipy } from "gif-picker-react/providers/klipy";

//@ts-ignore
const styleExpressionItem = "text-foreground";
//@ts-ignore
const styleExpressionItemMuted = "text-muted-foreground";

export function ExpressionGifPicker({
  onSelect,
}: {
  onSelect: (value: { type: string; value: string }) => void;
}) {
  const { theme } = useTheme();
  //@ts-ignore
  const { t, language } = useTranslation();
  //@ts-ignore
  const [expression, setExpression] = useState<string>("TENOR");

  const renderPicker = () => {
    if (expression === "TENOR") {
      return (
        <GifPicker
          provider={Klipy(import.meta.env.VITE_KLIPY_API_KEY)}
          onGifClick={(gif) =>
            onSelect({
              type: "GIF",
              value: gif.imageUrl,
            })
          }
          theme={theme as any}
        />
      );
    }

    console.error("Unknown expression:", expression);
    return null;
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" title="Add Expression" tabIndex={-1}>
          <ImagePlay className="h-4 w-4 mr-1" />
          {t("GIF")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-fit p-0" align="start">
        {renderPicker()}
        {/* <div className="flex p-1 justify-between border-t-2">
          <Button
            variant="ghost"
            title="Add Emoji"
            onClick={() => setExpression("Emoji")}
            className={
              expression === "Emoji"
                ? styleExpressionItem
                : styleExpressionItemMuted
            }
            tabIndex={-1}
          >
            <Smile className="h-4 w-4 mr-2" /> {t("Emoji")}
          </Button>
          <Button
            variant="ghost"
            title="Add Sticker"
            onClick={() => setExpression("Sticker")}
            className={
              expression === "Sticker"
                ? styleExpressionItem
                : styleExpressionItemMuted
            }
            tabIndex={-1}
          >
            <Sticker className="h-4 w-4 mr-2" /> {t("Sticker")}
          </Button>
          <Button
            variant="ghost"
            title="Add GIF"
            onClick={() => setExpression("GIF")}
            className={
              expression === "GIF"
                ? styleExpressionItem
                : styleExpressionItemMuted
            }
            tabIndex={-1}
          >
            <Image className="h-4 w-4 mr-2" /> {t("GIF")}
          </Button>
        </div> */}
      </PopoverContent>
    </Popover>
  );
}
